import { useState } from 'react';

export const CoffeeButNoWater = ({ ratio }) => {
  const [coffee, setCoffee] = useState('');

  const coffeeAmount = () => {
    const parse = coffee.replace(',', '.');
    const amount = parseFloat(parse, 10) * ratio;
    if (isNaN(amount)) {
      return 0;
    }

    if (amount === Infinity) {
      return 0;
    }

    return amount.toFixed(2);
  };

  return (
    <section>
      <h2>Jeg har kaffe, men ikke vann!</h2>
      <div>
        Jeg har
        <input
          className="number"
          placeholder="0"
          type="text"
          inputMode="decimal"
          pattern="[0-9]*"
          step="1"
          value={coffee}
          min={0}
          onChange={e => {
            setCoffee(e.target.value);
          }}
        />
        <span className="number">g</span> kaffe, så jeg trenger{' '}
        <span className="number">{coffeeAmount()}ml</span> vann!
      </div>
    </section>
  );
};
